module.exports = __webpack_public_path__ + "img/thumb_23.f8e32b5b.jpg";